// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3PeUg","title":"ClientInsurance_title__7-NEa","itemText":"ClientInsurance_itemText__3IZnZ"};